import Breadcrumbs from "../../../common/breadcrumb/Breadcrumbs"
import AddComplane from "../../../components/createCompalne/addComplane/AddComplne"


function AddCompalnePage() {
    return (
        <>
          <Breadcrumbs breadCrumbsTitle={{
    id: "1",
    title_1: "Help & Support",
    title_2: "Create Complain",
  }} />
            <AddComplane />
        </>
    )
}
export default AddCompalnePage